/**
 * CheckoutRedirectingPage — the splash shown in the NEW tab that opens when a
 * user starts checkout (see stores/checkoutStore.ts `openCheckout`). The
 * original tab creates the Stripe session, then points this tab at the Stripe
 * URL; until that happens we show the brand `CockpitLoader` (the same
 * 5-random-variant loader used for route transitions and on credia.pro).
 *
 * Route: /checkout/redirecting — top-level, no app chrome.
 *
 * The animation runs FAST (~700ms) to match the real checkout-session wait, then
 * HOLDS at 100% until this tab is navigated away to Stripe. (It can't know the
 * exact redirect moment — that's driven by the other tab — so we finish quickly
 * and wait at 100% rather than run a slow bar that gets cut off mid-way.)
 */

import { useState } from 'react';
import CockpitLoader from '../../../components/cockpit-loader/CockpitLoader';

const REDIRECT_LOADER_MS = 700;

export function CheckoutRedirectingPage() {
  // prefers-reduced-motion: CockpitLoader skips its animation; show a static
  // splash instead so the tab isn't blank while it waits for the redirect.
  const [reducedMotion] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );

  if (reducedMotion) {
    return (
      <div className="cockpit-loader-overlay">
        <p className="text-body text-txt-secondary">Opening secure checkout…</p>
      </div>
    );
  }

  return <CockpitLoader durationMs={REDIRECT_LOADER_MS} holdAtComplete />;
}
